import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { ShoppingCartService } from '@ridango/components';

@Component({
    selector: 'gl-other-purpose-modal',
    templateUrl: './other-purpose-modal.component.html',
    styleUrls: ['./other-purpose-modal.component.scss']
})
export class OtherPurposeModalComponent implements OnInit {
    @Input() purposeValue = '';
    public validOtherPurposeLength = this.shoppingCartService.getValidOtherPurposeLength;
    public purposeValueValidated = false;

    constructor(
        private modalCtrl: ModalController,
        private translate: TranslateService,
        public shoppingCartService: ShoppingCartService
    ) {}

    ngOnInit() {
        this.purposeValueValidated = this.purposeValue?.trim().length >= this.validOtherPurposeLength;
    }

    public async cancel(): Promise<void> {
        await this.modalCtrl.dismiss(null, 'cancel');
    }

    public async handleSaveClick() {
        if (this.purposeValue?.length < this.validOtherPurposeLength) {
            return;
        }

        await this.modalCtrl.dismiss(this.purposeValue, 'submit');
    }

    public validatePurposeValue(event: Event) {
        this.purposeValueValidated =
            (event.target as HTMLTextAreaElement).value?.trim().length >= this.validOtherPurposeLength;
    }
}
